import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { RestService } from "../app/rest.service";
import { AuthGuard } from "../app/auth.guard";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TreeviewModule } from "ngx-treeview";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { RegisterComponent } from "./register/register.component";
import { LoginComponent } from "./login/login.component";
import { ValidateComponent } from "./validate/validate.component";
import { AddUserComponent } from "./add-user/add-user.component";
import { HeaderComponent } from "./header/header.component";
import { ScheduleComponent } from "./schedule/schedule.component";
import { ActivityCatalogueComponent } from "./activity-catalogue/activity-catalogue.component";
import { InfrastructureComponent } from "./infrastructure/infrastructure.component";
import { AuditLogsComponent } from "./audit-logs/audit-logs.component";
import { AuthUserListComponent } from "./auth-user-list/auth-user-list.component";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { ProfileComponent } from "./profile/profile.component";
import { EnterpriseManagementComponent } from "./enterprise-management/enterprise-management.component";
import { AdminVerificationComponent } from "./admin-verification/admin-verification.component";
import { TimezoneComponent } from "./timezone/timezone.component";
import { NgbdTableSortableModule } from "./machine/machine.module";
import { JobsModule } from "./jobs/jobs.module";
import { EnvironmentsComponent } from "./environments/environments.component";
import { MasterTemplateComponent } from "./master-template/master-template.component";
import { JobPermissionComponent } from "./job-permission/job-permission.component";
import { InfraJobsComponent } from "./infra-jobs/infra-jobs.component";
import { InfraMaintenanceComponent } from "./infra-maintenance/infra-maintenance.component";
import { InfraJobOccurrencesComponent } from "./infra-job-occurrences/infra-job-occurrences.component";
import { InfraJobSeriesComponent } from "./infra-job-series/infra-job-series.component";
import { ActivityMOccurrenceComponent } from "./activity-m-occurrence/activity-m-occurrence.component";
import { ActivityMSeriesComponent } from "./activity-m-series/activity-m-series.component";
import { MultidatepickerComponent } from "./multidatepicker/multidatepicker.component";
import { ReviewDatepickerComponent } from "./review-datepicker/review-datepicker.component";
import { JobRecurringComponent } from "./job-recurring/job-recurring.component";
import { StartDatepickerComponent } from "./start-datepicker/start-datepicker.component";
import { EndDatepickerComponent } from "./end-datepicker/end-datepicker.component";
import { MaintenanceTypeComponent } from "./maintenance-type/maintenance-type.component";
import { MaintenanceSingleSelectionComponent } from "./maintenance-single-selection/maintenance-single-selection.component";
import { MaintenanceSingleDetailsComponent } from "./maintenance-single-details/maintenance-single-details.component";
import { MaintenanceSeriesSelectionComponent } from "./maintenance-series-selection/maintenance-series-selection.component";
import { MaintenanceSeriesDetailsComponent } from "./maintenance-series-details/maintenance-series-details.component";
import { MaintenanceSeriesReviewComponent } from "./maintenance-series-review/maintenance-series-review.component";
import { ScheduleCalendarComponent } from "./schedule-calendar/schedule-calendar.component";
import { ScheduleTableComponent } from "./schedule-table/schedule-table.component";
import { ScheduleTabsComponent } from "./schedule-tabs/schedule-tabs.component";
import { AuditMachineComponent } from "./audit-machine/audit-machine.component";
import { AuditJobsComponent } from "./audit-jobs/audit-jobs.component";
import { AuditSystemComponent } from "./audit-system/audit-system.component";
import { AuditUsersComponent } from "./audit-users/audit-users.component";
import { Angular2CsvModule } from "angular2-csv";
import { NotificationComponent } from "./notification/notification.component";
import { ScheduleEditJobComponent } from './schedule-edit-job/schedule-edit-job/schedule-edit-job.component';
import { ScheduleEditMaintenanceComponent } from './schedule-edit-maintenance/schedule-edit-maintenance/schedule-edit-maintenance.component';
import { RerenderDirective } from "./utils/rerender.directive";
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { StripePaymentsComponent } from './stripe-payments/stripe-payments.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { DirectorySetupModalComponent } from './directory-setup-modal/directory-setup-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    RegisterComponent,
    LoginComponent,
    ValidateComponent,
    AddUserComponent,
    HeaderComponent,
    ScheduleComponent,
    ActivityCatalogueComponent,
    InfrastructureComponent,
    AuditLogsComponent,
    AuthUserListComponent,
    ProfileComponent,
    EnterpriseManagementComponent,
    StripePaymentsComponent,
    AdminVerificationComponent,
    TimezoneComponent,
    EnvironmentsComponent,
    MasterTemplateComponent,
    JobPermissionComponent,
    InfraJobsComponent,
    InfraMaintenanceComponent,
    InfraJobOccurrencesComponent,
    InfraJobSeriesComponent,
    ActivityMOccurrenceComponent,
    ActivityMSeriesComponent,
    MultidatepickerComponent,
    ReviewDatepickerComponent,
    JobRecurringComponent,
    StartDatepickerComponent,
    EndDatepickerComponent,
    MaintenanceTypeComponent,
    MaintenanceSingleSelectionComponent,
    MaintenanceSingleDetailsComponent,
    MaintenanceSeriesSelectionComponent,
    MaintenanceSeriesDetailsComponent,
    MaintenanceSeriesReviewComponent,
    ScheduleCalendarComponent,
    ScheduleTableComponent,
    ScheduleTabsComponent,
    RerenderDirective,
    ScheduleEditJobComponent,
    ScheduleEditMaintenanceComponent,
    AuditMachineComponent,
    AuditJobsComponent,
    AuditSystemComponent,
    AuditUsersComponent,
    NotificationComponent,
    ForgotpasswordComponent,
    StripePaymentsComponent,
    PaymentConfirmationComponent,
    DirectorySetupModalComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AutocompleteLibModule,
    NgbModule,
    NgbdTableSortableModule,
    JobsModule,
    Angular2CsvModule,
    TreeviewModule.forRoot(),
  ],
  providers: [
    RestService,
    AuthGuard,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
